import { render, staticRenderFns } from "./BankEmployeeProfil.vue?vue&type=template&id=5829019c&"
import script from "./BankEmployeeProfil.vue?vue&type=script&lang=js&"
export * from "./BankEmployeeProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QSelect,QInput,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QSelect,QInput,QSeparator,QCardActions})
